class NavigationController {
    constructor() {
        this.elements = document.querySelectorAll(".js-nav");

        if (this.elements.length > 0) {
            import(/* webpackChunkName: "navigation" */ "../classes/Navigation")
                .then(({ default: Nav }) => new Nav(this.elements))
                .catch(err => console.error(err));
        }
    }
}

export default NavigationController;
